/**
 * This file is designed only for the events related to search within map. For example, 
 * when the toogle is activated or not.
 * It usually means that the action should have to save information on the store.
 */

import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from 'middlewares/googleTagManager';
import { addMiddleware } from 'redux-dynamic-middlewares';
import debounceEvent from '@redux-beacon/debounce-event';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import { mapStateActions } from 'features/searchResultsMap';
import { store } from '@redux/store';
import GoogleAnalyticsCustomDimensions from 'constants/googleAnalyticsCustomDimension';
import { geoCoordinates } from '../redux/selectors';

const mapSearchEvent = 'Map Search';

// Created the label with the current search coordinates
function getCoordinatesLabel() { 
  const coordinates = geoCoordinates(store.getState());
  const coordinatesLabel = `east: ${coordinates.east}, north: ${coordinates.north}, south: ${coordinates.south}, west: ${coordinates.west}`;
  
  return coordinatesLabel;
}

// Fires the event when the search within map functionality is activated. Gets current coordinates.
const toogleOn = () => { 
  const customDimensions = {};

  customDimensions[[GoogleAnalyticsCustomDimensions.SearchWithinMapActivated().getName()]] =
    'true';
  
    return   new GoogleAnalyticsEvent(mapSearchEvent, 'Toggle On', getCoordinatesLabel(), customDimensions);
}


// Fires the event when the search within map functionality is deactivated. Gets current coordinates.
  const toogleOff = () => { 
    const customDimensions = {};
  
    customDimensions[[GoogleAnalyticsCustomDimensions.SearchWithinMapActivated().getName()]] =
      'false';
    
      return   new GoogleAnalyticsEvent(mapSearchEvent, 'Toggle Off', getCoordinatesLabel(), customDimensions);
  }


const eventsMapper = (action) => {
    switch (action.type) {
      case mapStateActions.enableSearchWithinMap.type:
        return debounceEvent(100, toogleOn);
      case mapStateActions.disableSearchWithinMap.type:
        return debounceEvent(100, toogleOff);

      default:
        return [];
    }
  };
  
  const googleTagManager = new GoogleTagManager();
  const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMapper, googleTagManager.getTarget());
  addMiddleware(searchResultsGoogleTagManagerMiddleware);